import httpClient from '../http-client/index';

const login = async (email: string, password: string) => {
  const { data: response } = await httpClient.post('/session/login', {
    email,
    password,
  });

  if (!response.user || !response.user.is_admin) {
    localStorage.removeItem('halu-api-token');
    localStorage.removeItem('actual-halu-user');
    throw new Error('Você não possui acesso ao painel administrativo!');
  }

  if (response.api_token) {
    localStorage.setItem('halu-api-token', response.api_token);
    localStorage.setItem('actual-halu-user', JSON.stringify(response.user));
  }
};

export { login };
